function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { TriggerType } from "../../enum/TriggerType";
/**
 * トリガー情報　モデル
 */

var TriggerInfoInstanceModel =
/**
 * コンストラクタ
 *
 */
function TriggerInfoInstanceModel() {
  _classCallCheck(this, TriggerInfoInstanceModel);

  this.ObjectId = "";
  this.ObjectName = "";
  this.TriggerType = TriggerType.None;
  this.DependencyObjectId = "";
  this.DependencyObjectName = "";
  this.Distance = 1.0;
};

export { TriggerInfoInstanceModel as default };